<template>
  <b-sidebar v-model="menuOpen" :width="width" :header-class="headerClass" backdrop lazy shadow body-class="overflow-visible">
    <template v-slot:title>
      <slot name="title"></slot>
    </template>
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </b-sidebar>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
    width: {
      type: String,
      default: '300px',
      required: false,
    },
    headerClass: String,
  },
  computed: {
    menuOpen: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style scoped>
</style>
